<app-collapsible-section
  title="Offer Details"
  [isExpanded]="isExpanded"
  [isCompleted]="isCompleted"
  [showDoneButton]="true"
  (toggle)="onOfferDetailsToggle($event)"
  (done)="onOfferDetailsDone()"
>
  <ng-template #sectionContent>
    <div class="offer-details-content">
      <!-- Offer Type Section -->
      <div class="form-section">
        <label class="section-label">Offer Type</label>
        <div class="radio-group">
          <label class="radio-option">
            <input
              type="radio"
              name="offerType"
              value="flat_discount"
              [(ngModel)]="offerType"
              (ngModelChange)="onOfferTypeChange()"
            />
            <span class="radio-label">Flat Discount</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="offerType"
              value="way_earning"
              [(ngModel)]="offerType"
              (ngModelChange)="onOfferTypeChange()"
            />
            <span class="radio-label">Way Earning (Cashback)</span>
          </label>
        </div>
      </div>

      <!-- Discount Value Section -->
      <div class="form-section">
        <label class="section-label">Discount Value (%) <span class="required">*</span></label>
        <div class="input-container">
          <div class="input-wrapper" [class.error]="!isDiscountValueValid">
            <input
              type="number"
              class="number-input"
              [class.error-input]="!isDiscountValueValid"
              placeholder="e.g. 10"
              [(ngModel)]="discountValue"
              (ngModelChange)="onDiscountValueChange()"
              min="0"
              max="100"
              required
            />
            <div class="stepper-controls">
              <button
                type="button"
                class="stepper-btn"
                (click)="incrementValue(); onDiscountValueChange()"
              >
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 5L5 1L9 5"
                    stroke="#15172E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                type="button"
                class="stepper-btn"
                [class.disabled]="!isDiscountValueValid"
                [disabled]="!isDiscountValueValid"
                (click)="decrementValue(); onDiscountValueChange()"
              >
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="#15172E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <p class="input-help" *ngIf="isDiscountValueValid && !discountValueError">
            Provide a percentage value for the cashback
          </p>
          <div class="error-message" *ngIf="!isDiscountValueValid && discountValueError">
            {{ discountValueError }}
          </div>
        </div>
      </div>

      <!-- Car Wash Type Section -->
      <div class="form-section">
        <label class="section-label">Car Wash Type</label>
        <div class="checkbox-grid">
          <div class="checkbox-row">
            <div
              class="checkbox-item"
              *ngFor="let option of carWashTypeOptions.slice(0, 2); trackBy: trackByCarWashType"
            >
              <div class="p-field-checkbox">
                <mat-checkbox
                  [id]="'carWash-' + option.value"
                  [checked]="isCarWashTypeSelected(option.value)"
                  (change)="onCarWashTypeSelectionToggle(option.value, $event.checked)"
                ></mat-checkbox>
                <label [for]="'carWash-' + option.value" class="checkbox-label">{{
                  option.label
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Location Section -->
      <div class="form-section">
        <label class="section-label">Location <span class="required">*</span></label>
        <div class="checkbox-grid">
          <div class="checkbox-row">
            <div
              class="checkbox-item"
              *ngFor="let option of locationOptions; trackBy: trackByLocation"
            >
              <div class="p-field-checkbox">
                <mat-checkbox
                  [id]="'location-' + option.value"
                  [checked]="isLocationSelected(option.value)"
                  (change)="onLocationSelectionToggle(option.value, $event.checked)"
                ></mat-checkbox>
                <label [for]="'location-' + option.value" class="checkbox-label">{{
                  option.label
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="error-message" *ngIf="!isLocationValid && locationError">
          {{ locationError }}
        </div>
      </div>
      <div class="form-footer">
        <button
          class="btn btn-primary btn-medium"
          type="button"
          [disabled]="!isDiscountValueValid || !isLocationValid || isSaving"
          (click)="onOfferDetailsDone()"
        >
          <svg
            *ngIf="isSaving"
            class="done-spinner"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="8"
              cy="8"
              r="6"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-dasharray="31.416"
              stroke-dashoffset="8"
            />
          </svg>
          <span>{{ isSaving ? 'Saving...' : 'Done' }}</span>
        </button>
      </div>
    </div>
  </ng-template>
</app-collapsible-section>
